/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{useContext as t,useId as e,useEffect as r}from"react";import{PresenceContext as n}from"../../context/PresenceContext.js";function o(){const o=t(n);if(null===o)return[!0,null];const{isPresent:i,onExitComplete:s,register:c}=o,l=e();r((()=>c(l)),[]);return!i&&s?[!1,()=>s&&s(l)]:[!0]}export{o as usePresence};
//# sourceMappingURL=use-presence.js.map
